import ExportVast from './ExportVast';

const ExportVastDirective = (
  reactDirective,
  CreativeService,
  CreativeGroupService,
  MixpanelService
) => {
  return reactDirective(
    ExportVast,
    undefined,
    { restrict: 'E' },
    {
      CreativeService,
      CreativeGroupService,
      MixpanelService
    }
  );
};

ExportVastDirective.$inject = [
  'reactDirective',
  'CreativeService',
  'CreativeGroupService',
  'MixpanelService'
];

export default ExportVastDirective;
